//@ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { createSelector } from 'reselect';

import * as lessonSelectors from 'common.components/lesson/selectors';
import { getSubjectsWithStacks } from 'store/subject-config/selectors';
import { getSubjectFromProps } from 'utils/selectors/selectors';

import { ReduxTeacherStore } from '../../typings';

import { LessonWidgetStore } from './typings';

const storeStateSelector = (storeState: ReduxTeacherStore): LessonWidgetStore => storeState.lessonWidget;

export const getShouldShowWidget = createSelector(
    [storeStateSelector, lessonSelectors.getIsNew, getSubjectFromProps, getSubjectsWithStacks],
    (state, isNewLesson, subject: SUBJECTS_SLUGS | null, subjectsWithStacks): boolean => {
        const shouldShowWidget = state.shouldShowLessonWidget;
        const canAddStacks = subject ? subjectsWithStacks.includes(subject) : false;

        return canAddStacks && (!isNewLesson || shouldShowWidget);
    }
);

export const getShouldShowWidgetTooltip = createSelector(
    [storeStateSelector],
    (state: LessonWidgetStore): boolean => state.shouldShowLessonWidgetTooltip
);
